<template>
  <v-app id="inspire">
    <v-content>
      <v-container fluid fill-height class="login-app">
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4>
            <div class="login-brand">
              <img @click="goToHome" style="cursor: pointer;" src="../../assets/ead-viamaker-white.svg" alt="EAD Viamaker"/>
              <!-- <h2 @click="goToHome" style="cursor: pointer;"><b>EAD</b>Viamaker</h2> -->
            </div>

            <v-progress-linear v-if="loading" :indeterminate="true"></v-progress-linear>

            <!-- CADASTRO DE USUÁRIO -->
            <v-card class="elevation-12" v-else>
              <h3 class="text-center">Defina sua nova Senha</h3>

              <v-card-text v-if="!errorMessage" class="pb-0">
                <v-form ref="formRegister" v-model="valid" lazy-validation>
                  <v-text-field prepend-icon="email" v-model="email" label="Email" :rules="rules.email" :readonly="true" required></v-text-field>
                  <v-text-field prepend-icon="lock" v-model="password" label="Senha" type="password" :rules="rules.password" required></v-text-field>
                  <v-text-field prepend-icon="lock" v-model="passwordConfirmation" label="Confirmação da senha" type="password" :rules="rules.passwordConfirmation" required></v-text-field>
                </v-form>
              </v-card-text>
              <v-card-text v-else>
                <v-alert :value="errorMessage" type="warning" class="mb-0">
                  {{ errorMessage }}
                </v-alert>
              </v-card-text>
              <v-card-actions class="pb-3" v-if="!errorMessage">
                <v-btn style="margin: 0 auto;" @click="send" :loading="sending" color="primary">Alterar senha</v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
    <v-snackbar
      v-model="showAlert"
      :top="true"
      :color="colorAlert"
    >
      {{ textAlert }}
      <v-btn
        color="black"
        flat
        @click="showAlert = false">
        Fechar
      </v-btn>
    </v-snackbar>

  </v-app>
</template>

<script>
  import { encrypt } from '../../helpers'
  import { mapActions } from 'vuex'

  export default {
    data: () => ({
      valid: true,
      email: null,
      password: null,
      passwordConfirmation: null,

      loading: true,
      errorMessage: '',

      showAlert: false,
      textAlert: '',
      colorAlert: '',
      sending: false,

      rules: {
        email: [
          v => !!v || 'Preencha seu email',
          v => /.+@.+/.test(v) || 'Email inválido'
        ],
        password: [
          v => !!v || 'Preencha a nova senha',
          v => (v && v.length >= 6) || 'A senha precisa ter pelo menos 6 caracteres'
        ],
        passwordConfirmation: [
          v => !!v || 'Preencha a confirmação da senha'
        ]
      }
    }),
    watch: {
      showAlert (val) {
        if (!val) {
          this.textAlert = ''
          this.colorAlert = ''
        }
      }
    },
    methods: {
      ...mapActions(['setToken', 'setUser', 'setUserPermissions']),

      validate () {
        return this.$refs.formRegister.validate()
      },

      goToHome() {
        this.$router.push({ name: 'course-list' })
      },

      send () {
        if (this.validate()) {
          if (this.password !== this.passwordConfirmation) {
            this.colorAlert = 'error'
            this.textAlert = 'Confirmação da senha inválida'
            this.showAlert = true

            return false
          }

          const encryptObj = encrypt(this.password)

          const data = {
            token: this.$route.params.token,
            password: encryptObj.ciphertext,
            buffer: encryptObj.nonce
          }

          this.axios.post('/public/forgot-password/change', data).then(response => {
            if (response.data.success) {
              this.setUserData(response.data.user)

              this.showAlert = true
              this.colorAlert = 'success'
              this.textAlert = 'Bem vindo a plataforma'

              setTimeout(() => {
                this.$router.push({ name: 'course-list' })
              }, 2000)
            } else {
              this.colorAlert = 'warning'
              this.textAlert = (response.data.message ? response.data.message : 'Erro ao cadastrar')
              this.showAlert = true
            }
          })
        }
      },

      getToken () {
        const token = this.$route.params.token

        this.axios.get(`/public/forgot-password/token/${token}`).then(response => {
          if (response.data.success && response.data.userForgotPassword) {
            this.email = response.data.userForgotPassword.user.email
          } else {
            this.errorMessage = 'Token expirado'
          }
        }).catch(err => {
          this.errorMessage = 'Token inválido'
        }).finally(() => {
          this.loading = false
        })
      },

      setUserData (returnUserData) {
        this.setToken(returnUserData.token)
        this.setUser({ name: returnUserData.name, id: returnUserData._id })

        this.setUserPermissions(returnUserData.permission)
      }
    },
    created () {
      this.getToken()
    }
  }
</script>
